import type React from "react"

import { MeterCodeField } from "@/components/fields/meter-code-field"
import type { Meter } from "@/models/meter"
import { toIntervalMeterIdentity } from "@/services/interval"

interface IntervalDataMeterFilterProps {
  meters: Meter[]
  onMeterChange: (meter: Meter | null) => void
  selectedMeter: Meter | null
}

export const IntervalDataMeterFilter: React.FC<
  IntervalDataMeterFilterProps
> = ({ meters, onMeterChange, selectedMeter }) => (
  <MeterCodeField
    getOptionLabel={(meter) => toIntervalMeterIdentity(meter).label}
    meters={meters}
    onChange={onMeterChange}
    value={selectedMeter}
  />
)
